export const serviceMixin = {
  methods: {
    isServiceActive(service) {
      if (service == null) {
        return false
      }

      return service.Capabilities
    },
    serviceHasTenant(service, tenant) {
      return this.isServiceActive(service) && service.Capabilities.TenantIds.includes(tenant.Id)
    },
  },
}

export const ServiceTypesWithConfigurations = new Set([0, 1, 3])
export const ServiceTypes = {
  Report: 2,
}